import ImageWithFallback from 'components/ImageWithFallback';
import { dashboardFolder } from 'constants/Dashboard';
import Link from 'next/link';
import { ReactNode } from 'react';
import Chevron from '../../svg/ChevronLeft15.svg';
import styles from './EntriesAndStats.module.css';

interface StatSectionProps {
  title: string;
  icon: string;
  description: ReactNode;
  total: number;
  background: string;
  backgroundDesktop: string;
  link: string;
  onlyForSubscribedPlayer: boolean;
  isActiveSubscription: boolean;
}

const StatSection = ({
  title,
  icon,
  description,
  total,
  background,
  backgroundDesktop,
  link,
  onlyForSubscribedPlayer,
  isActiveSubscription,
}: StatSectionProps) => {
  const isLocked = onlyForSubscribedPlayer && !isActiveSubscription;

  return (
    <Link href={link} className={styles.statLink} key={title}>

      <div
        className={styles.statHeader}
        style={{
          ['--stat-background' as any]: `url(${background})`,
          ['--stat-background-desktop' as any]: `url(${backgroundDesktop})`,
        }}
      >
        {isLocked && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(217, 217, 217, 0.55)',
              zIndex: 1,
              borderRadius: 'inherit',
            }}
          />
        )}
        <div className={styles.statTotal}>
          <div className={styles.iconContainer}>
            <ImageWithFallback
              layout="fill"
              src={isLocked ? `${dashboardFolder}/lock-icon.svg` : icon}
              alt={title}
            />
          </div>
          {!isLocked ? <strong>{total}</strong> : null}
        </div>

        <h3
          className={`aboutUsTypographyHeaderMedium textAlignRight noMargin ${styles.textWhite}`}
        >
          {title}
        </h3>
      </div>
      <div className={styles.statFooter}>
        <div>{description}</div>
        <span className={styles.chevron}>
          <Chevron />
        </span>
      </div>

    </Link>
  );
};

export default StatSection;
